import { IPermissions } from '@routes'

export const calculateUserRoles = (
  role,
  canEdit,
  canRead
): { [role: string]: IPermissions } => ({
  [role]: { canEdit: !!canEdit, canRead: !!canRead }
})
